const ALERT_LABELS: Record<string, string> = {
  info: "Information",
  warning: "Important",
  success: "Bonne nouvelle",
};

export const enrichTemplateData = (templateId: string, data: Record<string, unknown>): Record<string, unknown> => {
  const enriched: Record<string, unknown> = { ...data, currentYear: new Date().getFullYear().toString() };

  if (templateId === "announcement" && enriched.alertType) {
    enriched.alertLabel = ALERT_LABELS[String(enriched.alertType)] || "Information";
  }

  return enriched;
};

export const BACKEND_PLACEHOLDERS_HELP =
  "La salutation « Bonjour Prénom Nom, » est insérée automatiquement pour chaque destinataire. Ne la répétez pas dans le message.";
